import * as _ from 'underscore';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import * as Config from '../config';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

import StringField from '../../../../_common/platform/ts/StringField';

const _init = [];

export function init(glob: IGlob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: Config.themeId,
            name: Config.name,
            parent: 'widget',

            themeType: Config.name,
            visibility: ['application', 'workspace', Config.moduleName]
        }
    ]);

    // appTheme.registerGroups([
    //     {
    //         id: Config.themeFields.,
    //         name: '',
    //         section: Config.themeId
    //     }
    // ]);

    appTheme.registerVars([
        {
            id: Config.themeFields.promptDialogTitile,
            param: new StringField(glob, 'Prompt Dialog Title', [], ''),
            section: Config.themeId
        },
        {
            id: Config.themeFields.promptDialogText,
            param: new StringField(glob, 'Prompt Dialog Text', [], ''),
            section: Config.themeId
        }
    ]);

    appTheme.registerPreRender(function (input) {
        var vars = {};

        return _.extend(input, vars);
    });

    _init.push(glob);
}
